import React, { useEffect, useState } from "react";
import { Table, Space, Button, Spin, Modal, Form, Input, Row, Col, message, Tooltip } from "antd";
import { convertIntoFormData, handlePdfDownload } from "../../utils/utils";
import { limitWords } from "../../utils/utils";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import MotionIconButton from "../../components/icons/MotionIcon";
import {
  DeleteOutlined,
} from '@ant-design/icons';
import DownloadOutlinedIcon from "../../components/icons/DownloadOutlineIcon";
import DeleteOutlinedIcon from "../../components/icons/DeleteOutlineIcon";

function MasterTemplate() {
  const [form] = Form.useForm();
  const [templateData, setTemplateData] = useState([]);
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileName, setFilename] = useState();
  const select = useSelector((state) => state.auth.userInfo);
  const compnayId = localStorage.getItem("companyId") || select.company_id;

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue();
      setIsFormLoading(true);
      const formData = convertIntoFormData({ ...values, template_file: fileName && fileName, company_id: compnayId });
      const response = await axiosInstance.post(`/contract/create_template/`, formData);
      if (response.status === 200) {
        message.success(response.data.message);
        fetchTemplates()
        setIsModalOpen(false);
        form.resetFields();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Validation or API Error:", error);
      // if (error.errorFields) {
      //   message.error("Please fill all required fields!");
      // }
    } finally {
      setIsFormLoading(false);
    }
  };

  const onCancel = () => {
    setIsModalOpen(false);
    setIsFormLoading(false);
    form.resetFields();
  };

  const fetchTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/create_template/?company_id=${compnayId}`);
      setIsLoading(false);
      setTemplateData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const fetchMasterTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-template/`);
      setIsLoading(false);
      setMasterTemplateData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchMasterTemplates();
    fetchTemplates();
  }, []);

  const deleteTemplate = async (id) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.delete(`/contract/create_template/`, {
        customParams: { master_template_id: id, company_id: compnayId }
      });
      setIsLoading(false);
      console.log(response)
      console.log(response.status)
      message.success("Template deleted successfully");
      fetchTemplates();
    } catch (error) {
      setIsLoading(false);
      message.error("Unable to delete template.")
    }
  };
  const handleDelete = (id) => {
    deleteTemplate(id)
  };
  const commonColumns = [
    {
      title: "Created By",
      width: 60,

      dataIndex: "created_by",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Template name",
      width: 150,

      dataIndex: "template_name",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Description",
      width: 400,
      dataIndex: "description",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Download",
      dataIndex: "template_file",
      width: 50,

      render: (_, record) => (
        <Space>
          <div
            onClick={() => handlePdfDownload(record.template_file)}
          >
            <DownloadOutlinedIcon />
          </div>
        </Space>
      ),
    },
  ];

  const templateColumns = [...commonColumns,
  {
    title: "Delete",
    dataIndex: "template_file",
    width: 50,

    render: (_, record) => (
      <Space>
        <div onClick={() => handleDelete(record.id)}>
          <DeleteOutlinedIcon />
        </div>
      </Space>
    ),
  },
  ];

  const masterTemplateColumns = commonColumns.map((col) => ({
    ...col,
    ellipsis: true,
  }));
  console.log(masterTemplateData, "masterTemplateData")

  return (
    <>
      <div className={` text-black pb-3 h-[60px] flex items-center justify-between `}>
        {/* {(select.role !== "superadmin") && <> */}
        <span>
          <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white"> {select.role === "superadmin" ? "Master Template" : "Template"} </h1>
        </span>
        {/* </>} */}
        <>
          <MotionIconButton classNam="float-right" tooltip="Add Templates" onClick={showModal} />

          <Modal
            open={isModalOpen}
            title="Add Template"
            onCancel={onCancel}
            footer={[
              <Button key="cancel" onClick={onCancel}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleOk}
                loading={isFormLoading}
              >
                Submit
              </Button>,
            ]}
          >
            <Form form={form} layout="vertical">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Template Name"
                    name="template_name"
                    rules={[
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter template name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Deacription" />
                  </Form.Item>
                </Col>
                <Row gutter={16}>
                  <Col>
                    <Form.Item
                      label="Select File"
                      name="template_file"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                      className="mr-2 attachment-input"
                    >
                      <Input
                        type="file"
                        accept=".doc, .docx"
                        onChange={(e) => setFilename(e.target.files[0])}
                        className="form-control"
                        required
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Row>
            </Form>
          </Modal>
        </>
      </div>
      {(select.role !== "superadmin") && <>

        <Spin spinning={isLoading} tip="Loading...">
          <Table
            dataSource={templateData && templateData}
            columns={templateColumns}
            pagination={false}
            bordered
            size="small"
            className="mb-4 template-table text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            scroll={{ x: "max-content" }}
          />
        </Spin>
      </>}

      {(select.role === "agreement controller team" || select.role === "professional agreement controller head" || select.role === "professional agreement controller team" || select.role === "agreement controller head" || select.role === "professional" || select.role === "superadmin") && <>
        {select.role !== "superadmin" &&
          <span>
            <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white ">
              Master Templates
            </h1>
          </span>}
        <Spin spinning={isLoading} tip="Loading...">
          <Table
            dataSource={masterTemplateData && masterTemplateData}
            columns={masterTemplateColumns}
            pagination={true}
            bordered
            size="small"
            className="mb-4 template-table text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            scroll={{ x: "1200" }}
          />
        </Spin>
      </>}
    </>
  );
}

export default MasterTemplate;
